module.exports = __webpack_public_path__ + "img/BG3.c2cbceb0.png";